export function isNotEmpty(value: any): boolean {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string' || Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === 'object' && value !== null) {
        return Object.keys(value).length > 0;
    }
    return true;
}

export function  isEmpty(value: any) {
    return !isNotEmpty(value);
}

export function nullToBlank(str:String | undefined | null): string{
    if(str === undefined || str === null){
        return "";
    }
    // @ts-ignore
    return str;
}

export function concatPath(str1:string, str2:string, str3 = "") {
    let slash_str = "/";
    let slice_r = str1.slice(-1);
    let slice_l = str2.slice(0, 1);

    let concat_str;

    let str_left = str1;
    let str_right = str2;
    if(slash_str === slice_r && slash_str === slice_l) {
        // 末尾1文字を削除
        str_left = str_left.slice(0, -1);
        concat_str = str_left + str_right;
    } else if(slash_str !== slice_r && slash_str !== slice_l) {
        concat_str = str_left + slash_str + str_right;
    } else {
        concat_str = str_left + str_right;
    }
    return concat_str + str3;
}

export function removeCommaToString(dcChrVal: string | undefined): string{
    if(dcChrVal === undefined || dcChrVal === null){
        return "";
    }
    const val = removeComma(dcChrVal);
    if(val === null){
        return "";
    }else {
        return val.toString();
    }
}

export function removeComma(dcChrVal: string): number | null{
    if(!isNotEmpty(dcChrVal))
        return null;

    let dcMinus = false;
    //マイナス判定
    if(dcChrVal.charAt(0) === '-'){
        dcMinus = true;
        dcChrVal = dcChrVal.substr(1);
    }


    let dcDivComma = dcChrVal.split(",");
    let dcResVal = "";
    for(let dcCnt=0; dcCnt<dcDivComma.length; dcCnt++){
        dcResVal = dcResVal + dcDivComma[dcCnt];
    }


    if(dcMinus) dcResVal = "-" + dcResVal;

    return parseFloat(dcResVal);
}

export function replaceHtmlNewLine(str: string | undefined): string{
    if(str === undefined || str === null){
        return "";
    }
    return str.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />');
}

export function isEmptyList(list : any) {
    return list === null || list === undefined || list.length === 0;
}

export function isNotEmptyList(list : any) {
    return !isEmptyList(list);
}


/**
 * is for boolean
 * @param bool_value
 * @returns {boolean}
 */
export function isBool(bool_value: any): boolean {
    if(bool_value === "true" || bool_value === "True" || bool_value === true) {
        return true;
    } else if(bool_value === "false" || bool_value === "False" || bool_value === false) {
        return false;
    } else {
        return false;
    }
}

/**
 * equal for Number
 * @param target1 target value1
 * @param target2 target value2
 * @returns {boolean}
 */
export function equalsNumber(target1: any, target2:any) {
    let target1_num = Number(target1);
    let target2_num = Number(target2);
    if(isNaN(target1_num) || isNaN(target2_num)) {
        return false;
    }
    return target1_num === target2_num;
}

export function isShowLogErrorPage(errorList:string[] | undefined | null): boolean{
    if(errorList && errorList.length > 0){
        const errorMsg = errorList[0];
        if(errorMsg.indexOf("SHOW_ERROR_LOG_PAGE") !== -1){
            return true;
        }
    }
    return false;
}